import React from "react";
import { useDispatch } from "react-redux";
import { MultipleSelectFilter } from "@thecb/components";
import { setAppliedFilters } from "../AdministeredUsers.state";
import { multipleSelectFiltersConfig } from "../AdministeredUsers.state";

export const MultiSelectFilterForm = ({
  options,
  autocompleteValue,
  fields,
  actions,
  filterName = "",
  appliedFilters,
}) => {
  const dispatch = useDispatch();
  const filterConfig = multipleSelectFiltersConfig.find(
    (filter) => filter.key === filterName
  );

  const handleOnApply = (options) => {
    dispatch(setAppliedFilters({ filterName: filterName, filterOptions: options }));
  };

  return (
    <>
      {options && options.length !== 0 && fields && (
        <MultipleSelectFilter
          autocompleteValue={autocompleteValue}
          filterLabel={filterConfig.displayName}
          hasIcon={!!filterConfig.icon}
          icon={filterConfig.icon}
          options={options}
          name={filterConfig.key}
          placeholder={filterConfig.placeholder}
          fields={fields}
          actions={actions}
          onApply={(options) => handleOnApply(options)}
          activeAppliedOptions={appliedFilters || []}
        />
      )}
    </>
  );
};
